export const bonusTypesEnum = {
  freeSpin: 1,
  jackpot: 2,
  boostedJackpot: 4,
};
